// extracted by mini-css-extract-plugin
module.exports = {"boost_section":"style_boost_section__12cFB","boost_section__container":"style_boost_section__container__2tqur"};